module.exports = __webpack_public_path__ + "img/logo.e95d5474.svg";